/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import moment from 'moment';
import { DatePicker, Form, Tooltip } from 'antd';
import { Button as CrceButton } from '@crc-evans/ui-components';
import { ArrowLeft, ThumbsDown, ThumbsUp, Hourglass } from 'lucide-react';
//import FilterLogs from './FilterLogs';
import {
  fetchCalenderDetails,
  fetchLogDetails,
  generateLogReports,
} from '../../redux/logDetails/action';
import { fetchSowDetails } from '../../redux/PQTsowDetails/actions';
import { getPopupContainerBody } from '../ShippingManagement/shipmentFieldOptions';
import GenerateReport from './GenerateReport';
import LogCalender from './LogCalender';
import './PQTResultsPage.css';

const DATE_DROPDOWN = 'modern-dropdown-popup mc-dpr-datepicker-dropdown pqt-results-date-dd';

const defaultYearRange = () => ({
  fromDate: moment().startOf('year').format('YYYY-MM-DD'),
  toDate: moment().endOf('year').format('YYYY-MM-DD'),
});

const PQTResultsPage = (props) => {
  //setting up start date and end date of month for filters and getting log details
  var nowdate = new Date();
  var monthStartDay = new Date(nowdate.getFullYear(), nowdate.getMonth(), 1);
  var monthEndDay = new Date(nowdate.getFullYear(), nowdate.getMonth() + 1, 0);

  const {
    onFetchLogDetails,
    logDetails,
    showLogLoader,
    selectedProject,
    onFetchSowDetails,
    sowDetails,
    onGenerateLogReports,
    onFetchCalenderDetails,
    isCalenderLoading,
    calenderData,
    isLogReportsLoading,

    showPQTResultPage,
    setShowPQTResultPage,
    selectedSOW,
    pipelineList,
    //projectTeamMembersAccessList,,
    // userAccessList
  } = props;

  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [isReportModalVisible, setIsReportModalVisible] = useState(false);
  const [columnList, setColoumList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [filter, setFilter] = useState(false);
  const [projectIdValue, setProjectIdValue] = useState(false);

  const [pipeline, setPipeline] = useState(null);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [yearData, setYearData] = useState(moment().format('YYYY'));
  const [monthData, setMonthData] = useState(moment().format('MM'));
  const [calenderList, setCalenderList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [calenderForm] = Form.useForm();
  const [calenderView, setCalenderView] = useState(true);
  const [calenderClass, setCalenderClass] = useState('view');
  const [fileURL, setFileURL] = useState('');
  /** When set (month calendar), materials/weather API uses this single day like legacy; year view uses full month. */
  const [mwiFocusDay, setMwiFocusDay] = useState(null);
  /** Date range from LogCalender RangePicker — drives table + View Details / Recalculate. */
  const [logCalendarDateRange, setLogCalendarDateRange] = useState(defaultYearRange);
  /** Incremented after Recalculate so `LogCalender` refetches `pqt-report/inspection-report-data`. */
  const [inspectionLogRefreshKey, setInspectionLogRefreshKey] = useState(0);
  const isWriteAccess = true;

  useEffect(() => {
    setLogCalendarDateRange(defaultYearRange());
    setMwiFocusDay(null);
  }, [selectedSOW?.id]);

  const onResultsCalendarNavigate = useCallback(({ day, mode, year, month }) => {
    setYearData(String(year));
    setMonthData(month);
    setMwiFocusDay(mode === 'month' ? day : null);
  }, []);

  const handleLogDateRangeChange = (dates) => {
    const nextFrom =
      dates?.[0] && dates[0].isValid() ? dates[0].format('YYYY-MM-DD') : null;
    const nextTo =
      dates?.[1] && dates[1].isValid() ? dates[1].format('YYYY-MM-DD') : null;
    if (!nextFrom || !nextTo) return;
    setLogCalendarDateRange({ fromDate: nextFrom, toDate: nextTo });
  };

  const materialsWeatherDateRange = useMemo(() => {
    if (logCalendarDateRange?.fromDate && logCalendarDateRange?.toDate) {
      return logCalendarDateRange;
    }
    if (mwiFocusDay) {
      return { fromDate: mwiFocusDay, toDate: mwiFocusDay };
    }
    const m = moment(`${yearData}-${monthData}-01`, 'YYYY-MM-DD');
    return {
      fromDate: m.clone().startOf('month').format('YYYY-MM-DD'),
      toDate: m.clone().endOf('month').format('YYYY-MM-DD'),
    };
  }, [yearData, monthData, mwiFocusDay, logCalendarDateRange]);

  // useEffect(() => {
  //     if (fileURL) {
  //         let fileName = fileURL.split('/').pop(); // Gets the last part of the URL
  //         fileName = decodeURIComponent(fileName); // Decodes any encoded characters

  //         let a = document.createElement('a');
  //         a.href = fileURL;
  //         a.download = fileName || "PQT_Log_Report.pdf"; // Use extracted filename, fallback if not available
  //         document.body.appendChild(a);
  //         a.click();
  //         document.body.removeChild(a);
  //         // a.click();
  //         // let link = document.createElement('a')
  //         // link.href = fileURL
  //         // a.download = fileName || "PQT_Log_Report.pdf";
  //         // link.click()
  //     }

  // }, [fileURL])

  // /** Fetching API to get  Location details for generating report */
  // useEffect(() => {
  //     const projId = get(selectedProject, 'id', undefined);
  //     if (projId) {
  //        // onFetchSowDetails(projId);
  //         setLocationData([]);
  //         setPipeline('');
  //         setSelectedPipeline('');
  //         setYearData(moment().format('YYYY'));
  //         setMonthData(moment().format('MM'));
  //         calenderForm.resetFields();
  //         setCalenderList([]);
  //         setDataList([]);
  //         setColoumList([]);
  //         setCalenderView(true);
  //         setCalenderClass('view')

  //     }
  //     setProjectIdValue(projId);
  // }, [selectedProject]);

  // /** Getting Location details for generating report */
  // useEffect(() => {
  //     setLocationData(sowDetails);
  // }, [sowDetails]);

  // /**API call for fetching Log Details */
  // useEffect(() => {
  //     const projectId = get(selectedProject, 'id', undefined);
  //     var obj = {
  //         projectId: projectId,
  //         fromDate: moment(monthStartDay).format('YYYY-MM-DD'),
  //         toDate: moment(monthEndDay).format('YYYY-MM-DD'),
  //     }
  //     console.log(obj)
  //     onFetchLogDetails(obj);
  //     setFilterText('');
  //     setFilter(false);
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedProject]);

  /**Get Log Data */
  useEffect(() => {
    let logColoums = [];
    let logDataSource = [];
    if (logDetails) {
      setTotalCount(logDetails.totalCount);
      if (logDetails.columns) {
        logDetails.columns.map((item) => {
          item.width = 170;
          item.align = 'center';
          // item.ellipsis = true
          item.ellipsis = {
            showTitle: false,
          };
          (item.render = (address) => (
            <Tooltip placement="topLeft" title={address}>
              {address}
            </Tooltip>
          )),
            (item.render = (text, record) => {
              return (
                <div>
                  {text === 'accept' ? (
                    <ThumbsUp
                      className="pqt-results-status-icon pqt-results-status-icon--accept"
                      size={20}
                      strokeWidth={2}
                      aria-label="Accepted"
                    />
                  ) : text === 'reject' ? (
                    <ThumbsDown
                      className="pqt-results-status-icon pqt-results-status-icon--reject"
                      size={20}
                      strokeWidth={2}
                      aria-label="Rejected"
                    />
                  ) : text === 'pending' ? (
                    <Tooltip title="Pending">
                      <Hourglass
                        className="pqt-results-status-icon pqt-results-status-icon--pending"
                        size={20}
                        strokeWidth={2}
                        aria-hidden
                      />
                    </Tooltip>
                  ) : (
                    text
                  )}
                </div>
              );
            }),
            logColoums.push(item);
        });

        logColoums.forEach((item, i) => {
          if (item.title === 'Weld') {
            item.title = 'Weld #';
            item.width = 200;
            item.align = 'center';
            item.fixed = 'left';
            item.ellipsis = {
              showTitle: false,
            };
            (item.render = (address) => (
              <Tooltip placement="topLeft" title={address}>
                {address}
              </Tooltip>
            )),
              logColoums.splice(i, 1);
            logColoums.unshift(item);
          }

          if (item.title === 'Repair Status') {
            item.fixed = 'right';
            logColoums.splice(i, 1);
            logColoums.splice(logColoums.length - 1, 0, item);
          }

          if (item.title === 'Overall Status') {
            item.fixed = 'right';
            // logColoums.splice(i, 1);
            // logColoums.push(item);
          }
        });
        // Adding S.No to table values
        // logColoums.unshift({
        //     "title": "S.No",
        //     "dataIndex": "count",
        //     "key": "count",
        //     width: 60,
        //     align: 'center',
        //     ellipsis: true,
        //     fixed: 'left'
        // });

        logColoums.forEach((item, i) => {
          if (item.title) {
            item.ellipsis = {
              showTitle: false,
            };
            item.title = <Tooltip title={item.title}>{item.title}</Tooltip>;
          }
        });

        logColoums.forEach((item, i) => {
          if (item.title) {
            item.ellipsis = {
              showTitle: false,
            };
            item.title = <Tooltip title={item.title}>{item.title}</Tooltip>;
          }
        });
        setColoumList(logColoums);
      }

      if (logDetails.dataSource) {
        var sizeCount = JSON.parse(sessionStorage.getItem('page'));
        logDetails.dataSource.map((item, i) => {
          if (sizeCount.pageIndex > 0) {
            item.count = i + 1 + sizeCount.pageSize * sizeCount.pageIndex;
          } else {
            item.count = i + 1;
          }

          logDataSource.push(item);
        });
        setDataList(logDataSource);
      }
    }
  }, [logDetails]);

  useEffect(() => {
    if (calenderData) {
      setCalenderList(calenderData);
    }
  }, [calenderData]);

  /** Function call for getting data on applying filter */
  const onFilter = (fromDate, toDate) => {
    const projectId = get(selectedProject, 'id', undefined);
    var obj = {
      projectId,
      fromDate,
      toDate,
    };
    onFetchLogDetails(obj);
    setFilterText(
      `${moment(fromDate).format('DD/MM/YYYY')} - ${moment(toDate).format('DD/MM/YYYY')}`
    );
    setFilter(true);
  };

  /** Fucntion call to get data after removing filter */
  const handleLogData = () => {
    const projectId = get(selectedProject, 'id', undefined);
    var obj = {
      projectId: projectId,
      fromDate: moment(monthStartDay).format('YYYY-MM-DD'),
      toDate: moment(monthEndDay).format('YYYY-MM-DD'),
    };
    onFetchLogDetails(obj);
  };

  /** Function call for getting data on applying filter */
  const onGenerateReport = async (data) => {
    await onGenerateLogReports(data);
  };

  const getCalData = async (data) => {
    await onFetchCalenderDetails(data);
  };

  return (
    <div className="modern-pqt-results-page">
      <div className="pqt-results-toolbar">
        <div className="pqt-results-toolbar-main">
          <CrceButton
            label="Back"
            variant="tertiary"
            size="medium"
            icon={ArrowLeft}
            onClick={() => {
              setShowPQTResultPage(false);
            }}
            aria-label="Back to pipelines"
          />
          <h2 className="pqt-results-title">Pipeline: {selectedSOW.pipelineSection}</h2>
        </div>
        <div className="pqt-results-toolbar-actions inspection-logs">
          <div className="pqt-results-range-picker-wrap">
            <DatePicker.RangePicker
              className="pqt-results-range-picker"
              allowClear={false}
              format="DD-MMM-YYYY"
              value={
                logCalendarDateRange?.fromDate && logCalendarDateRange?.toDate
                  ? [
                      moment(logCalendarDateRange.fromDate, 'YYYY-MM-DD'),
                      moment(logCalendarDateRange.toDate, 'YYYY-MM-DD'),
                    ]
                  : null
              }
              onChange={handleLogDateRangeChange}
              placeholder={['Start date', 'End date']}
              dropdownClassName={DATE_DROPDOWN}
              getPopupContainer={getPopupContainerBody}
              separator={<span className="pqt-results-range-sep">–</span>}
            />
          </div>
          <GenerateReport
            isReportModalVisible={isReportModalVisible}
            setIsReportModalVisible={setIsReportModalVisible}
            setLocationData={setLocationData}
            locationData={locationData}
            projectIdValue={projectIdValue}
            onGenerateReport={onGenerateReport}
            isLogReportsLoading={isLogReportsLoading}
            isWriteAccess={isWriteAccess}
            selectedSOW={selectedSOW}
            selectedProject={selectedProject}
            pipelineList={pipelineList}
            setFileURL={setFileURL}
            logDateRange={materialsWeatherDateRange}
            onAfterRecalculateSuccess={() =>
              setInspectionLogRefreshKey((k) => k + 1)
            }
          />
        </div>
      </div>
      <hr className="pqt-results-divider" />
      <div className="pqt-results-body">
            {/* {dataList.length > 0 ?
                            <Table
                                columns={columnList}
                                dataSource={dataList}
                                // filtered={true}
                                loading={showLogLoader}

                                pagination={false}
                                scroll={{ x: '100%', y: '100%' }}
                            /> :
                            <Table
                                loading={showLogLoader}
                            />} */}

            <LogCalender
              selectedSOW={selectedSOW}
              onResultsCalendarNavigate={onResultsCalendarNavigate}
              activeLogDateRange={logCalendarDateRange}
              inspectionLogRefreshKey={inspectionLogRefreshKey}
            />
      </div>
    </div>
  );
};

const mapStateToProps = ({ log, sow }) => {
  const logDetails = get(log, 'logData', []);
  const reportsData = get(log, 'reportsData', []);
  const showLogLoader = get(log, 'isLogDetailsLoading', false);
  const sowDetails = get(sow, 'sowData', []);
  const isCalenderLoading = get(log, 'isCalenderLoading', []);
  const calenderData = get(log, 'calenderData', []);
  const isLogReportsLoading = get(log, 'isLogReportsLoading', []);
  return {
    logDetails,
    showLogLoader,
    sowDetails,
    reportsData,
    isCalenderLoading,
    calenderData,
    isLogReportsLoading,
  };
};

const mapDispatchToProps = {
  onFetchLogDetails: fetchLogDetails,
  onFetchSowDetails: fetchSowDetails,
  onGenerateLogReports: generateLogReports,
  onFetchCalenderDetails: fetchCalenderDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(PQTResultsPage);
